"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Circle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Box_1 = require("../Box");
function Circle(_a) {
    var { diameter, maxDiameter, minDiameter, blink: blinkSpeed } = _a, props = __rest(_a, ["diameter", "maxDiameter", "minDiameter", "blink"]);
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({}, props, { borderRadius: "50%", width: diameter, height: diameter, maxHeight: maxDiameter, maxWidth: maxDiameter, minHeight: minDiameter, minWidth: minDiameter }), void 0));
}
exports.Circle = Circle;
//# sourceMappingURL=index.js.map